module.exports = __webpack_public_path__ + "static/media/arrow.74f29513.png";